import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { filter, isEqual, without } from 'lodash';
import LoaderContainer from '../components/shared/loaderContainer/LoaderContainer';
import DynamicFormFieldRenderer from '../components/Reusable/DynamicFormFieldRenderer';
import styled from 'styled-components';
import { clipboard, clipboardCheck } from '../assets/components/svgs';
import Modal from '../components/shared/ModalPortal/Modal';
import Card from '../components/shared/cards/Card';
import InputField from '../components/shared/Fields/InputField';

const Container = styled.div`
  width: 100%;
  background-color: #f5f5f5;
  min-height: 25vh;
  max-height: 75vh;
  overflow: auto;
`;

interface CopyModalProps {
  templateCopy: boolean;
  setTemplateCopy: Function;
  callBackCopy: Function;
  modalHeader: string;
  plcaceHolder: string;
}

const CopyModal: React.FC<CopyModalProps> = ({
  templateCopy,
  setTemplateCopy,
  callBackCopy,
  modalHeader,
  plcaceHolder
}) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [formError, setFormError] = useState<any>({
    templateName: ''
  });
  const [formData, setFormData] = useState<any>({
    templateName: ''
  });

  const handleChange = (e: any) => {
    setFormData({ ...formData, templateName: e.target.value });
  };

  return (
    <>
      {templateCopy && (
        <Modal
          showHeader={true}
          showCloseIcon={true}
          width="30rem"
          headerText={modalHeader}
          toggleVisiblity={(value: boolean) => {
            setTemplateCopy(false);
          }}
          isVisible={true}
          overflowVisible={true}
          className=""
          body={
            <InputField
              className="w-full"
              type="text"
              id="duplicate"
              label={plcaceHolder}
              placeholder={plcaceHolder}
              fieldKey="templateName"
              required={false}
              formData={formData}
              setFormData={() => {}}
              handleChange={handleChange}
              formError={{}}
              disabled={false}
            />
          }
          secondaryOnClick={() => setTemplateCopy(false)}
          secondaryButtonText={t('T_CANCEL')}
          secondaryButtonWidth={'100px'}
          primaryButtonText={t('T_OK')}
          primaryButtonWidth={'100px'}
          primaryOnClick={() => {
            callBackCopy(formData.templateName.trim());
            setFormData({ templateName: '' });
          }}
          primaryButtonDisabled={!formData.templateName.trim()}
        />
      )}
    </>
  );
};

export default CopyModal;
